import { getCookie } from './utils';
import { onReady } from './utils.js';

onReady( function() {
	const forms = document.querySelectorAll( 'form[action*="www.paypal.com"]' );

	if ( forms.length === 0 ) {
		return;
	}

	forms.forEach( ( form ) => {
		form.addEventListener( 'submit', () => {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push( {
				event: 'donate',
				donate_type: 'PayPal',
			} );
		} );
	} );
} );

onReady( function() {
	const donationCookie = getCookie( 'donation-cta-show-1' );
	const donationCTA = document.querySelector( '.c-notification_floating' );

	if ( donationCTA && ( ! donationCookie || parseInt( donationCookie, 10 ) < Math.round( new Date().getTime() / 1000 ) ) ) {
		donationCTA.hidden = false;
	}
} );
